import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import profileBg from '../../images/patterns/profilebg.png';
import lessonmenuicon  from '../../images/icons/lessonmenuicon.png';
import lessonmenuiconwhite from '../../images/icons/lessonmenuiconwhite.png';
import sidebar_props from '../../model/AppConstants.js';
import HmAjax from '../../util/HmAjax';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import UserStorageUtil from '../../util/UserStorageUtil';
import ChooseGrade from './ChooseGrade';
import "../../css/Sidebar.css";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import $ from 'jquery';
import ComponentRegistry from '../../model/ComponentRegistry';
import HmEventRegistry from '../../model/HmEventRegistry';
import menusJson from '../../config/sidebarMenus.json';

let menus = sidebar_props.menus;
const loadingView = "loadingView";
const topicView = "topicView";
const subTopicView = "subTopicView";
const messageView = "messageView";
const productExpiredView = "productExpiredView";
const allTopicsView = "allTopicsView";
const pointsSystemView = "pointsSystemView";
const noProductView = "noProductView";
const homeView = "homeView";
export default class Sidebar extends LoggedInPage {
	
	constructor(props) {
		super(props);

		this.state = {
			selectedID:0,
			userName:this.getUser().getUserName(),
			imagePreviewUrl:"",
			imageLoaded:false,
			productArr:[],
			gradeArr:[],
			productExpired:false,
			noProducts:false,
			view: homeView,
			lessonIconDisplay:lessonmenuicon,
			grademodalShow:false,
			grademodalTitle:"Test",
			grademodalContent:""
		}

		this.openProfile = this.openProfile.bind(this);
		this.sideBarDropdownChange = this.sideBarDropdownChange.bind(this);
		this.handleMouseOver = this.handleMouseOver.bind(this);
		this.handleMouseOut = this.handleMouseOut.bind(this);
		this.gradeChangefromChooseGrade = this.gradeChangefromChooseGrade.bind(this);
		this.showHideLeftMenu = this.showHideLeftMenu.bind(this);

		this.accessId = 0;
		this.gradeProductMap = {};
		this.classDefnMap={};
		this.selectedGradeOption = null;
		this.selectedProductOption = null;
		this.comboNamesLoaded = false;
		this.gradeStore = null;
		this.homeDropDownKey = "homeDropdown";
		this.preferredGrade = null;
		this.preferredProduct = null;
		this.gradeStore = null;

		this.entlKey = null;

		this.getProductCount = this.getProductCount.bind(this);
		this.showFormobile=this.showFormobile.bind(this);
		this.getMenusFromJson = this.getMenusFromJson.bind(this);

		this.goTo = this.goTo.bind(this);
	}

	updateUserName(username){
		this.setState({userName:username});
	}

	componentDidMount(){
		var me = this;
		this.props.onRef(this);	
		this.loadCurrentImage();

		this.setState({selectedID:0});
		
		if(this.productsAvailableToAccess()){
			this.setPreferredDd();
			if(this.props.childComponentName == "DASHBOARD"){
				this.getGradeListDashboard();
			}else{
				this.getGradeListTopic();
			}
			
		}else{
			this.setState({noProducts:true,view:noProductView});
			setTimeout(function(){	  			
				$(".page-content nav.side-navbar ul li").addClass("noclicks");
				me.sideBarDropdownChange();
			},300);			
			
		}
		
		try{
			var isCollapsed = (this.getAttribute("sidebar_collapsed") === "true");
			
  			sidebar_props.collapsed = isCollapsed ||  sidebar_props.collapsed;

  			if(sidebar_props.collapsed === true){
  				$(".page-content .content-inner").toggleClass("fullwidth");
  				$(".page-content nav.side-navbar").toggle();
  				$(".page-content nav.side-navbar").toggleClass('collapsed');
  			}
  		}catch(e){
  			console.error(e);
		  }
	}

	gradeSorter(response){
		let allCountryMap = {};

		Object.values(response).map((grade, index) => {
			if(grade && grade.countryCode){
				let tempArr = allCountryMap[grade.countryCode];
				if(!tempArr){
					tempArr = [];
					allCountryMap[grade.countryCode] = tempArr;
				}
				tempArr.push(grade);	
			}	
		});

		for(let each in allCountryMap){
			const sorter = window.choose_grade_sorter[each] || window.choose_grade_sorter["ALL"];
			let sortedArr = allCountryMap[each];
			const sortingField = sorter.field;
			
			if(sortingField && sortedArr && sortedArr.length > 0 && sortedArr[0][sortingField]){
							const sortingType = sorter.type || (!isNaN(sortedArr[0][sortingField]) ? "number" : "string");

							sortedArr.sort((a,b) => {
								if(sortingType === "number"){
									return a[sortingField] - b[sortingField];
								}else if(sortingType === "string"){
									if(a[sortingField] && b[sortingField]){
										if(a[sortingField].toLowerCase() < b[sortingField].toLowerCase()){
											return -1;
										}else if(a[sortingField].toLowerCase() > b[sortingField].toLowerCase()){
											return 1;
										}
									}
								}

								return 0;					
							})
						}

			sortedArr = (sorter.order === "desc") ? sortedArr.reverse() : sortedArr;
		}

		let sortedGrades = {};
		let leastGradePerCountry = {};

		Object.values(allCountryMap).map((gradeArr, ind) => {
			if(gradeArr && gradeArr.length > 0){
				gradeArr.map((grade, gInd) => {
					sortedGrades[String(grade.classId)] = grade;
					if(!leastGradePerCountry[grade.countryCode]){
						leastGradePerCountry[grade.countryCode] = grade;
					}
				});
			}
		})
		//console.warn("lalala unsorted :: ", response);
		//console.warn("lalala sorted :: ", sortedGrades);
		//console.warn("lalala leastGradePerCountry :: ", leastGradePerCountry);
		return sortedGrades;
	}

  	compoenentWillMount(){
  		this.props.onRef(undefined);	  
	}
	  
  	gradeDropdownChange(gradeOption, prodOption){		
  		this.selectedGradeOption = gradeOption;	
  		this.selectedProductOption = prodOption;

  		this.getProductList();		
  	}

  	gradeChange(event){
  		var me = this;
  		var selectedIndex = parseInt(event.currentTarget.dataset.index);
  		this.selectedGradeOption = this.state.gradeArr[selectedIndex];

  		this.getProductList();
  	}

  	gradeChangefromChooseGrade(gradeIndex, prodIndex, entlKey){
  		this.setPreferredDd();
  		this.selectedGradeOption = this.state.gradeArr[gradeIndex];
  		this.selectedProductOption = this.state.productArr[prodIndex];
  		this.entlKey = entlKey;
  		this.getProductList();
  		this.hidegradeModal();
  	}

  	productChange(event){	
		var me = this;
  		var selectedIndex = parseInt(event.currentTarget.dataset.index);
		this.selectedProductOption = (this.state.productArr && this.state.productArr.find((elem) => (elem.id == selectedIndex))) ? this.state.productArr.find((elem) => (elem.id == selectedIndex)) : null;		
		if(!this.selectedProductOption){
			return;
		}else{
			this.setPreferredDd();
		}
			
  		this.setState({selectedID:parseInt(event.currentTarget.dataset.id)})
		if(event.currentTarget.dataset.label.toLowerCase() == "lessons"){
			this.setState({selectedID:parseInt(event.currentTarget.dataset.id),lessonIconDisplay: lessonmenuiconwhite});			
			
		}else{
			this.setState({selectedID:parseInt(event.currentTarget.dataset.id),lessonIconDisplay: lessonmenuicon});
		}
		
		this.sideBarDropdownChange(true);
		
		try{
			this.gradeStore = {
				"grd":this.selectedGradeOption.value,
				"prod":this.selectedProductOption.value
			}
			this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore), () => {me.props.routingMenus("/landing");});
		}catch(e){
			me.props.routingMenus("/landing");
		}

	  }

	  productsAvailableToAccess(){
	  	var user = this.getUser();
	  	if(user != null){
				var permissions = user.getEntlHistory();
	  		if(permissions != null && Object.keys(permissions).length > 0){
	  			for(var i in permissions){
	  				if(permissions[i] != null){
	  					var totalLevel = permissions[i].split(",").reduce(function(a,b){
	  						try{
	  							return parseInt(a) + parseInt(b);
	  						}catch(e){
	  							return 0;
	  						}
	  					});

	  					if(totalLevel > 0){
	  						return true;
	  					}
	  				}
	  			}
	  		}
	  	}

	  	return false;
	  }

	  setPreferredDd(){
	  	try{
	  		var gradeStore = null;
	  		var prefStr = this.getAttribute(this.homeDropDownKey);
	  		if(prefStr)
	  			gradeStore = JSON.parse(prefStr);

			if(typeof gradeStore === "object"){
				this.preferredGrade = gradeStore["grd"];
				this.preferredProduct = gradeStore["prod"];;
			}
		
		}catch(e){}
	}
	getGradeListDashboard(){		
		var me = this;

		var callBack = function(response){
			var grades = response.classId;
			var products = response.accessId;
			
			var classDefnMap = response.classDefn;
			me.gradeProductMap =  response.gradeProdMap;
			me.classDefnMap = classDefnMap;

			var gradeArr =[];
			var preselectIndex = 0;
			let groupedGradesList = [];
			
			if(grades !== null && grades.length > 0){
				for(var i=0;i<grades.length;i++){
					if(grades[i] > 0){
						try{
							var dropDownLabel = me.rb(classDefnMap[grades[i]].className);

							if(classDefnMap[grades[i]] && classDefnMap[grades[i]].gradeId){
							/**
							* IMPORTANT: Replace classId with gradeId when available.
							* This is for grouped classes
							*/
								let gradeDisplayName = me.rb(classDefnMap[grades[i]].gradeDisplayName);
							
								classDefnMap[grades[i]]["label"] = gradeDisplayName;
								classDefnMap[grades[i]]["value"] = grades[i];
								gradeArr.push(classDefnMap[grades[i]]);
							
						}else{
							classDefnMap[grades[i]]["label"] = dropDownLabel;
							classDefnMap[grades[i]]["value"] = grades[i];
							gradeArr.push(classDefnMap[grades[i]]);
						}

					}catch(e){
					}
				}
			}
		}

		if(gradeArr && gradeArr.length > 0){
			for(var i=0; i< gradeArr.length; i ++){
				if(gradeArr[i].value == (me.preferredGrade)){ 
						preselectIndex = i;
					}
				}
			}

			me.selectedGradeOption = gradeArr[preselectIndex];
			me.setState({gradeArr:gradeArr});
			me.getProductList();
		}


		this.getClassNamesDashboard(callBack);

	}
	getClassNamesDashboard(callBack){
		var me = this;
		var callBackSuccess = function(response){
			me.comboNamesLoaded = true;
			callBack.apply(this,[response]);
		}

		var callBackFailure = function(error){
			me.showAlert(me.rb("503.title"),me.rb("503.msg"));
		}

		new HmAjax(this.getUrlFor("DASH_COMBO_DATA")).get(callBackSuccess,callBackFailure);	
	}
	getGradeListTopic(){		
		var me = this;
		var gradeProductMap = this.gradeProductMap;
		var entlhistory = this.getUser().getEntlHistory();
		
		for(var i in entlhistory){
			try{
				if(entlhistory[i] !== undefined && entlhistory[i] !== null && entlhistory[i].length > 0){
					var tempKeysArr =  entlhistory[i].split(",");
					if(tempKeysArr.length > 0){
						for(var j=0;j<tempKeysArr.length ; j++){
							var existingArr = gradeProductMap[tempKeysArr[j]];
							if(existingArr === undefined || existingArr === null){
								existingArr = [];
							}
							existingArr.push(i);

							gradeProductMap[tempKeysArr[j]] = existingArr;
						}
					}
				}
			}catch(e){
				console.error(e);
			}
		}

		this.gradeProductMap = gradeProductMap;

		let groupedGradesList = [];

		var grades = Object.keys(gradeProductMap);
		var callBack = function(classDefnMap){
			var gradeArr =[];
			var preselectIndex = 0;
			me.classDefnMap=classDefnMap;
			
			if(grades !== null && grades.length > 0){
				for(var i=0;i<grades.length;i++){
					if(grades[i] > 0){
						try{
							var dropDownLabel = me.rb(classDefnMap[grades[i]].className);
							if(classDefnMap[grades[i]] && classDefnMap[grades[i]].gradeId){
							/**
							* IMPORTANT: Replace classId with gradeId when available.
							* This is for grouped classes
							*/							
						
								let gradeDisplayName = me.rb(classDefnMap[grades[i]].gradeDisplayName);
							
								classDefnMap[grades[i]]["label"] = gradeDisplayName;
								classDefnMap[grades[i]]["value"] = grades[i];
								gradeArr.push(classDefnMap[grades[i]]);
							
						}else{
							classDefnMap[grades[i]]["label"] = dropDownLabel;
							classDefnMap[grades[i]]["value"] = grades[i];
							gradeArr.push(classDefnMap[grades[i]]);
						
						}
					}catch(e){
					}
				}
			}
		}

		if(gradeArr && gradeArr.length > 0){
			for(var i=0; i< gradeArr.length; i ++){
				if(gradeArr[i].value == (me.preferredGrade)){ 
					preselectIndex = i;
				}
			}

		}

			me.selectedGradeOption = gradeArr[preselectIndex];
			me.setState({gradeArr:gradeArr});
			me.getProductList();
			
		}
		

		this.getClassNamesTopic(grades, callBack);

	}
	getClassNamesTopic(classIds,callBack){
		var me = this;
		var callBackSuccess = function(response){
			me.comboNamesLoaded = true;
			let sortedArr = me.gradeSorter(response);
			callBack.apply(this,[response]);
		}

		var callBackFailure = function(error){
			me.showAlert(me.rb("503.title"),me.rb("503.msg"));
		}

		new HmAjax(this.getUrlFor("CLASS_DEFN"),classIds).post(callBackSuccess,callBackFailure);	
	}
	getProductList(){
		var preselectIndex = 0;
		var gradeProductMap = this.gradeProductMap;

		var permissionMap = this.getUser().getPermissions();
		var permissions = gradeProductMap[this.selectedGradeOption.value];
		var accessMap = this.getUser().getAccessMap();
		let reverseAccessMap = this.getUser().getReverseAccessMap();
		var lessonIconDisplay = lessonmenuicon;
		if(permissions.length > 0){
			var productArr = [];
			
			for(var i=0;i<permissions.length;i++){
			
				var classCode = this.classDefnMap[this.selectedGradeOption.value].classCode;
				var board = this.classDefnMap[this.selectedGradeOption.value].board
				
				
				var label = this.rb(accessMap[permissions[i]] + "-" + classCode + "-" + board  ) || this.rb("label-"+permissions[i] + "-" + classCode + "-" + board);
				
				if((label === accessMap[permissions[i]] + "-" + classCode + "-" + board) || (label === "label-"+permissions[i] + "-" + classCode + "-" + board)){
					label = this.rb(accessMap[permissions[i]]+"-menu") || this.rb("label-"+permissions[i]);
				}
				
				
				var materilkey = 'assignment';
				if(permissions[i] == 3){
					materilkey = 'ondemand_video';
				}

			 	if(reverseAccessMap){
					 permissions[i] = reverseAccessMap[accessMap[permissions[i]]];
			  }

				productArr.push({entlKey:accessMap[permissions[i]],"label":label,"value":permissions[i],'id':permissions[i],'materialkey':materilkey});
			if(permissions[i] == parseInt(this.preferredProduct)){

				preselectIndex = i;
				if(parseInt(this.preferredProduct) == 3){  
				lessonIconDisplay = lessonmenuiconwhite;
				}
		}

	}				
	this.selectedProductOption = productArr[preselectIndex];		

	var selectedProductId = this.selectedProductOption.id;
	let prodClicked = false;
	if(this.props.childComponentName == "DASHBOARD"){
		selectedProductId = 1001;
		lessonIconDisplay = lessonmenuicon;
	}else{
		prodClicked = true;
	}

	this.setState({productArr:productArr,selectedID:selectedProductId,lessonIconDisplay:lessonIconDisplay});			
	this.sideBarDropdownChange(prodClicked);
}else{
	this.setState({message:this.rb("home.not_entitled"), view:messageView});
	this.sideBarDropdownChange();
	this.showAlert("",this.rb("home.not_entitled"));
}
}


openProfile(){
	try{
	this.props.myProps.history.push("/settings");
	  }catch(e){

	  }

	}
	
	profilePicToggle(enable){
		var elems = document.getElementsByClassName("avatar");

		if(enable){
			if(elems && elems.length > 0){
				elems[0].classList.add("active");
				elems[0].classList.remove("inactive")
			}
		}else{
			if(elems && elems.length > 0){
				elems[0].classList.add("inactive");
				elems[0].classList.remove("active")
			}
		}

	}
	
	sideBarDropdownChange(isProductClicked=false){
		this.props.sideBarDropdownChange(this.selectedGradeOption,this.selectedProductOption,this.comboNamesLoaded,this.state,isProductClicked)	
	}
	
	leftmenuclick(event){
		this.setState({selectedID:(event.currentTarget.dataset.id),lessonIconDisplay:lessonmenuicon});
		this.props.routingMenus(event.currentTarget.dataset.value);
	}
	
	deleteCurrentImage(){
		this.setState({imageLoaded:false});
	}
	
	loadCurrentImage(){
		var me = this;
		var success = function(response){
			if(response && response.imgUrl){
				me.setState({imagePreviewUrl:response.imgUrl, imageLoaded:true});
			}
		} 

		var failure = function(err){

		}

		new HmAjax(this.getUrlFor("PROFILE_PIC")).get(success, failure);
	}
	
	setCurrentImage(imageUrl){
		this.setState({imagePreviewUrl:imageUrl, imageLoaded:true});
	}
	
	/*
	* IMPORTANT: This is the place to modify the menus to be rendered dynamically - Shyam
	*/
	getSideBarMenus(){
		var me = this;
		let elements = menus.map((element,index) => {   
			return (<li key={index} className={me.rb(element.label)+" leftmenu "+(parseInt(this.state.selectedID) === parseInt(element.id) ? "active" : "")} onClick={this.leftmenuclick.bind(this)} data-id={element.id} data-value={element.value}><a> <i className="material-icons">{element.materialkey}</i> <span className="leftmenutxt">{me.rb(element.label)}</span> </a></li>)
		})
		return elements;

	}
	showGradeSelection(){		
		if(this.getProductCount() < 2){
			return;
		}

		this.setState({ grademodalShow: true, grademodalContent:this.getGradeMoalContent(), grademodalTitle:""});
	}

	getProductCount(){
		let orphanClassIds = new Set();
		let groupedGradeIds = new Set();
		let tempGradeArr = this.state.gradeArr;
		if(tempGradeArr && tempGradeArr.length > 0){
			for(let i =0; i<tempGradeArr.length; i++){
				if(tempGradeArr[i] && tempGradeArr[i].classId){
					if(!isNaN(tempGradeArr[i].gradeId) && tempGradeArr[i].gradeId > 0){
						groupedGradeIds.add(tempGradeArr[i].gradeId);
					}else if(!isNaN(tempGradeArr[i].classId) && tempGradeArr[i].classId > 0){
						orphanClassIds.add(tempGradeArr[i].classId);
					}
				}
			}
			return (orphanClassIds.size + groupedGradeIds.size);
		}else{
			return 0;
		}

		//return (this.state.gradeArr) ? this.state.gradeArr.length : 0;
	}

	getGradeMoalContent(){		
		return (<ChooseGrade gradeArr={this.state.gradeArr} gradeProductMap={this.gradeProductMap}  selectedGradeOption={this.selectedGradeOption} selectedProductOption={this.selectedProductOption} gradeChangefromChooseGrade={this.gradeChangefromChooseGrade}/>);
	}
	hidegradeModal(){
		this.setState({ grademodalShow: false, grademodalContent:"", grademodalTitle:""});
	}
	loadgradeModalContent(){
		if (this.state.grademodalContent != "") {
			return(
				<div>
				{this.state.grademodalContent}
				</div>
				)
			}
		}

	getLabelByBoard(element){
		let board = (element && element.board) ? element.board : null;

		const labelFieldsForBoard = (board && window.choose_grade_label_fields_for_boards && window.choose_grade_label_fields_for_boards[board]) ? window.choose_grade_label_fields_for_boards[board] : null;

		if(labelFieldsForBoard != null){
			if(labelFieldsForBoard.length > 1){
				return this.rb(element[labelFieldsForBoard[1]]);
			}
			return this.rb(element[labelFieldsForBoard[0]]);
		}else if(board && board.toUpperCase() === "RSA"){
			if(element && element.classDescription && element.classDescription.length > 0){
				return this.rb(element.classDescription);
			}else if(element && element.className && element.className.length > 0){
				return this.rb(element.className);
			}
		}

		return null;
	}


		getGradeMenus(){
			var me = this;

			let gradeMenuTxt = this.getLabelByBoard(this.selectedGradeOption);

			if(gradeMenuTxt && gradeMenuTxt.length > 0){
				//Do nothing
			}else if(this.selectedGradeOption && this.selectedGradeOption.gradeDisplayName && this.selectedGradeOption.gradeDisplayName.length > 0 && this.selectedGradeOption.gradeDisplayName !== "null"){
				gradeMenuTxt = this.rb(this.selectedGradeOption.gradeDisplayName);
			}else if(this.selectedGradeOption && this.selectedGradeOption.classDescription && this.selectedGradeOption.classDescription.length > 0 && this.selectedGradeOption.classDescription !== "null"){
				return this.rb(this.selectedGradeOption.classDescription);
			}else{
				//Older approach
				gradeMenuTxt = this.rb(this.selectedGradeOption.label);
			}



			const singleGradeMenuStyle = {pointerEvents:"none",opacity:0.7}
			if(this.getProductCount() < 2){
				return (
				<li className="" style={singleGradeMenuStyle}>
				<a className="" href="#" id="navbardrop">
				<i className="material-icons">school</i> 
				<span className="leftmenutxt">{gradeMenuTxt}</span>
				</a>    
				</li>
				);
			}else{
				return (
				<li className="" onClick={this.showGradeSelection.bind(this)}>
				<a className="" href="#" id="navbardrop">
				<i className="material-icons">school</i> 
				<span className="leftmenutxt">{gradeMenuTxt}</span>
				<i className="material-icons absolute">arrow_right</i> 
				</a>	      
				</li>
				);
			}

			}
			handleMouseOver(event) {		
				this.setState({
					lessonIconDisplay: lessonmenuiconwhite
				});    
			}

			handleMouseOut(event) {
				if(!$(event.currentTarget).hasClass("active")){
					this.setState({
						lessonIconDisplay: lessonmenuicon
					});
				}

			}

			isLessonTabAvailable(){
		//This is restricted to only Mobile check for now
		return this.showFormobile();
	}

	showFormobile(){
		var isMobileOrTab = this.isTab() || this.isMobile();

		var lessonLockForGrades =  window.lessonLockForGrades || [];
		var gradeVal = !isNaN(this.selectedGradeOption.value) ? Number(this.selectedGradeOption.value) : 0;

		return !(lessonLockForGrades.indexOf(gradeVal) > -1 && isMobileOrTab);
	}
	

	getProductMenus(){
		var me = this;

		let elements = this.state.productArr.map((element,index) => {   
			if(element.label.toLowerCase() == "lessons"){
				return (<li key={index} data-ga={"Post login - "+this.selectedGradeOption.label+" - "+element.label} className={element.label+" leftmenu "+(parseInt(this.state.selectedID) === parseInt(element.id) ? "active" : "")} data-index={index} data-id={element.id} data-value={element.value} data-label={element.label} onClick={this.productChange.bind(this)} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><a> <i className="va-inherit"><img className="material-icons" src={this.state.lessonIconDisplay} /></i> <span className="leftmenutxt">{element.label}</span> </a></li>)
			}
			else{
				return (<li key={index} data-ga={"Post login - "+this.selectedGradeOption.label+" - "+element.label} className={element.label+" leftmenu "+(parseInt(this.state.selectedID) === parseInt(element.id) ? "active" : "")} data-index={index} data-id={element.id} data-value={element.value} data-label={element.label} onClick={this.productChange.bind(this)}><a> <i className="material-icons">{element.materialkey}</i> <span className="leftmenutxt">{element.label}</span> </a></li>)
			}

		})
		return elements;
	}
	showHideLeftMenu(){
		$(".page-content .content-inner").toggleClass("fullwidth");
		$(".page-content nav.side-navbar").toggle();
		$(".page-content nav.side-navbar").toggleClass('collapsed');

			var isCollapsed = $('nav.side-navbar').hasClass('collapsed');


			if(typeof isCollapsed === "boolean"){
				this.setAttribute("sidebar_collapsed",isCollapsed.toString());	
			}


			sidebar_props.collapsed =  $('nav.side-navbar').hasClass('collapsed');
			UserStorageUtil.storeSessionItem("sidebar_collapsed",sidebar_props.collapsed);

    }

    getMenusFromJson(){
    	let me = this;
    	let accessMap = me.getUser().getAccessMap();
		let reverseAccessMap = me.getUser().getReverseAccessMap();

    	if(menusJson && Object.keys(menusJson).length > 0){
    		return Object.values(menusJson).map((element, index) => {
    			let menuAvailable = false;
		
    			if(element && element.allowedEntlKeys && element.allowedEntlKeys.length > 0 && me.state.productArr && me.state.productArr.length > 0){
    				me.state.productArr.map((prod, idx) => {
						//console.warn("lalala menus loop::" ,me.state.productArr," : ",index);
						if(prod && prod.entlKey &&  (element.allowedEntlKeys && element.allowedEntlKeys.length > 0 && (~element.allowedEntlKeys.indexOf(prod.entlKey)))){
							menuAvailable = true;
							return;
						}
    				});
    			}else{
					menuAvailable = true;
				}
				
    			if(element && menuAvailable){
						if(reverseAccessMap && element.entlKey && element.entlKey.length > 0 && !isNaN(reverseAccessMap[element.entlKey])){
							element.id = reverseAccessMap[element.entlKey];
							element.value = reverseAccessMap[element.entlKey];
							element.index = reverseAccessMap[element.entlKey];
					 	}
    				return (<li key={index} onClick={me.goTo} data-ga={"Post login - "+me.selectedGradeOption.label+" - "+element.label} className={element.label+" leftmenu "+(me.state.selectedID == element.id ? "active" : "")} data-route={element.route} data-index={element.index} data-id={element.id} data-value={element.value} data-label={element.label}><a> <i className="material-icons">{element.materialkey}</i> <span className="leftmenutxt">{element.label}</span> </a></li>);
    			}	

    		});
    	}
		}
		
		goTo(element){
			let route = element.currentTarget.dataset.route || '';
			if(route!=''){
			  this.productChange(element);
			}
			else{
				this.leftmenuclick(element);
			}
		}

		
	/*
	* IMPORTANT: This is the place to modify the menus to be rendered dynamically - Shyam
	*/
	renderSidebarTab(){
		var me=this;
		return (
			<ul className="list-unstyled">	
			{( ()=> {
				if(me.comboNamesLoaded){
					return (
						<div>
						{me.getGradeMenus()}
						{/* {me.getProductMenus()} */}
					{me.getMenusFromJson()}
					</div>
					);	
				}

			})()}

			{/* {me.getSideBarMenus()} */}
			</ul>
			)
				}

				renderHumburger(){
					return (
						<div className="showhidemenu">
			    	<a id="toggle-btn" href="#" className="menu-btn active" onClick={this.showHideLeftMenu}>
			    		<i className="material-icons">menu</i>
			    	</a>
			    </div>	
					)
				}

				render() {
					var headerImgStyle = {			 
						backgroundImage: 'url(' + profileBg + ')',
						backgroundSize:"cover"
					};

					return (
						<div className="pos_relative">

				{this.renderHumburger()}

			    <nav className="side-navbar">			  

				{this.renderSidebarTab()}

				</nav>

				<div>							
				<TestTakingModalComponent visible={this.state.grademodalShow} dialogClassName="fullwidthdiag grademodal">
				<div className="modal-header bg-purple">
				<div className="modal-title">
				{this.state.grademodalTitle}
				</div>
				<div className="close" onClick={this.hidegradeModal.bind(this)} data-ga={"Post login - Choose your Class - Close"} aria-label="Close">
				<span aria-hidden="true"><i className="material-icons">close</i></span>
				</div>
				</div>
				<div className="modal-body testModalBody">
				{this.loadgradeModalContent()}
				</div>							
				</TestTakingModalComponent>
				</div>

				</div>
				);
				}
			}

			ComponentRegistry.register("Sidebar",Sidebar);


// WEBPACK FOOTER //
// ./src/views/common/Sidebar.js